import React from 'react'
import { withAuthenticationRequired, useAuth0 } from '@auth0/auth0-react'
import Dashboard from '../Dashboard'
import AuthLoader from './common/AuthLoader'

const ProtectedDashboard = () => {
  const { isLoading } = useAuth0()
  if (isLoading) {
    return <AuthLoader />
  }
  return <Dashboard />
}

export default withAuthenticationRequired(ProtectedDashboard, {
  onRedirecting: () => <AuthLoader />,
})
